import { Header, Footer, Hero, About } from '@/modules/landing/components';

export function Home() {
  return (
    <div className="bg-alpine-950 min-h-screen">
      <Header />
      <main>
        <Hero />
        <About />
      </main>
      <Footer />
    </div>
  );
}
